import type { Sticker } from '../types';

export const kitchen: Sticker[] = [
  {
    id: 15001,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/001-bakery.png',
    name: 'Piekarnia',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15002,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/002-cooking.png',
    name: 'Gotowanie',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15003,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/003-kitchen-utensils.png',
    name: 'Przybory Kuchenne',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15004,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/004-bread.png',
    name: 'Chleb',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15005,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/005-pot.png',
    name: 'Garnek',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15006,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/006-cooking.png',
    name: 'Kucharz',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15007,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/007-cooking.png',
    name: 'Kuchnia',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15008,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/008-cooking.png',
    name: 'Przygotowanie Posiłku',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15009,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/009-bakery.png',
    name: 'Wypieki',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15010,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/010-french-press.png',
    name: 'French Press',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15011,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/011-cooking.png',
    name: 'Gotowanie w Garnku',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15012,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/012-cooking.png',
    name: 'Smażenie',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15013,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/013-mixer.png',
    name: 'Mikser',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15014,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/014-cutlery.png',
    name: 'Sztućce',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15015,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/015-cooking.png',
    name: 'Pieczenie',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15016,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/016-pot.png',
    name: 'Patelnia',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15017,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/017-pressure-cooker.png',
    name: 'Szybkowar',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15018,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/018-strainer.png',
    name: 'Sitko',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15019,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/019-toaster.png',
    name: 'Toster',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 15020,
    url: 'https://stickers.nauczniaczek.pl/colections/13559978-kitchen-utensils/png/020-drink.png',
    name: 'Napój',
    category: 'kitchen',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];